import { useEffect, useRef, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { useWs } from "@/context/WsContext";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { ScrollArea } from "@/components/ui/scroll-area";
import { Send } from "lucide-react";

export default function JobChat({ jobId }) {
  const { user } = useAuth();
  const { addMessageListener } = useWs();
  const [messages, setMessages] = useState([]);
  const [text, setText] = useState("");
  const bottomRef = useRef(null);

  useEffect(() => {
    api.get(`/jobs/${jobId}/messages`).then((r) => setMessages(r.data));
    const off = addMessageListener((m) => {
      if (m.job_id === jobId) setMessages((prev) => (prev.some((x) => x.id === m.id) ? prev : [...prev, m]));
    });
    return off;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [jobId]);

  useEffect(() => { bottomRef.current?.scrollIntoView({ behavior: "smooth" }); }, [messages]);

  const send = async (e) => {
    e.preventDefault();
    if (!text.trim()) return;
    const content = text;
    setText("");
    await api.post(`/jobs/${jobId}/messages`, { content });
  };

  return (
    <div className="flex flex-col h-[420px]" data-testid="job-chat">
      <ScrollArea className="flex-1 border border-border rounded-md p-3 bg-slate-50">
        {messages.length === 0 && <div className="text-center text-sm text-muted-foreground py-8">No messages yet. Say hello!</div>}
        <div className="space-y-3">
          {messages.map((m) => {
            const mine = m.sender_id === user.id;
            return (
              <div key={m.id} className={`flex ${mine ? "justify-end" : "justify-start"}`} data-testid="chat-message">
                <div className={`max-w-[75%] rounded-md px-3 py-2 text-sm ${mine ? "bg-ocean text-white" : "bg-white border border-border"}`}>
                  {!mine && <div className="text-[11px] font-semibold text-ocean mb-0.5">{m.sender_name}</div>}
                  <div className="text-left">{m.content}</div>
                  <div className={`text-[10px] mt-1 ${mine ? "text-white/70" : "text-muted-foreground"}`}>
                    {new Date(m.created_at).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })}
                  </div>
                </div>
              </div>
            );
          })}
          <div ref={bottomRef} />
        </div>
      </ScrollArea>
      <form onSubmit={send} className="flex gap-2 mt-3">
        <Input value={text} onChange={(e) => setText(e.target.value)} placeholder="Type a message…" data-testid="chat-input" />
        <Button type="submit" className="bg-ocean hover:bg-ocean/90" data-testid="chat-send"><Send className="w-4 h-4" /></Button>
      </form>
    </div>
  );
}
